import KeyControl from "./KeyControl";
import MouseControl from "./MouseControl";

export default class Controls {
	constructor(stage) {
		this.keyControl = null;
		this.mouseControl = null;
		this.n = 0;
		this.s = 0;
		this.e = 0;
		this.w = 0;
		this.fired = 0;
		this.enabled = false;
		this.stage = stage;
	}

	destroy() {
		this.keyControl.destroy();
		this.mouseControl.destroy();
	}

	init() {
		this.keyControl = new KeyControl(this.controlHandler.bind(this));
		this.keyControl.init();
		this.mouseControl = new MouseControl(this.controlHandler.bind(this));
		this.mouseControl.init();
	}

	reset() {
		this.n = 0;
		this.s = 0;
		this.e = 0;
		this.w = 0;
		this.fired = 0;
	}

	enable(lFlag) {
		this.enabled = lFlag;
		this.keyControl.enable(lFlag);
		this.mouseControl.enable(lFlag);
	}


	controlHandler(control) {
		this.n = 0;
		this.s = 0;
		this.e = 0;
		this.w = 0;
		this.fired = 0;
		this.n = control.n;
		this.s = control.s;
		this.e = control.e;
		this.w = control.w;
		this.fired = control.fired;
		//console.log(this.fired);

	}


}

